module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item10-049368e7fd7437027bfb746290e6dc38.svg";